/*
 Created by CHT 2020/9/11 20:01
 */

import {
  DATA_TYPE__STRING,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__MEMBER, FORM_ITEM__RELATE_RECORD,
  FORM_ITEM__RTF,
  FORM_ITEM__SECTION,
  FORM_ITEM__TABLE,
  FORM_STATUS__FILL,
  PERMISSION__EDITOR,
  PERMISSION__HIDDEN,
  PERMISSION__READ
} from './types'
import {uuid, getId} from "./utils"
import RyFormItem from './RyFormItem'

class BaseItem extends RyFormItem {
  constructor(dataId) {
    super()

    // 标题草稿不能超过20字 不提交服务器
    this.temTitle = this.title
    // 失焦或者提交表单等操作时 内容验证失败 为 true  平时为 false
    this.verify = false
    // 指向根(formSet)
    this.root = null


    // id
    this.dataId = dataId || uuid(this.type.toLocaleUpperCase() || '')

    // 标题 不能超过20字符
    this.fieldTitle = ''
    // 控件的描述 不能超过100字符
    this.fieldDes = '提示内容...'
    // 提示信息，鼠标放入后提示
    this.fieldHint = ''
    // 前端使用 原封返回 后端不做处理
    this.fieldDetail = {}
    // 全局引用名称
    this.envVarName = ''
    // 控件宽度 25 50 75 100
    this.percent = 100

    // 依赖信息
    this.dependOnList = []
    // 依赖提交字段 0 否 1 是 公式计算使用 或 关联数据
    this.dependSubmit = 0
    // 新版依赖信息，自己变化导致的目标字段变化的fieldId
    this.followList = []

    // 是否独占一行 默认独占1行 0 否 1 是
    this.singleLine = 1
    // 是否必填
    this.required = 0
    // 是否重复
    this.repeated = 1
    // 是否作为标题 0否 1是 全表单最多有且只有一个标题
    this.forTitle = 0
    // 隐藏字段 0否 1是
    this.hidden = 0
    // 是否根据单选关联控件隐藏，不提交服务器，还原结构时动态计算
    this.isRelateField = 0
    // 当前是否有单选控件选中并且关联当前控件
    this.followShowList = []
    // 是否可编辑
    this.edit = 1
    // 权限
    this.permission = this.permissionOptional[0].value
    // 是否检查过未填的必填项,初始值给false，点击提交表单按钮后会判断，然后再修改这个值，之后每个未填的必填控件就会显示必填提示
    this.checkMissValue = false

    this.errorText = '' // 提交校验错误信息

    // 子表单控件宽度，仅子表单控件使用
    this.width = '240'
    // 控件值是否修改过
    this.modified = false

    this.showContact = false // 当前是否有选人pop框弹出，为了解决点返回键只退出选人，不退出页面问题

    this.pluginConfig = null // 字段设置的插件
    this.bothRelateInfo = null // 双向连接对象

    // 字段显示设置
    this.displayInfo = {
      edit: 1,
      show: 1,
      showCustom: 0,
      color: '#ffffff',
      alertMsg: ""
    }
    // 字段关联的显隐规则id列表
    this.fieldShowRuleIds = []
    this.fieldEditRuleIds = []
    this.fieldCustomRuleMap = {}

    // 绑定插件按钮配置
    this.triggerType = 2 //1 焦点触发 2 失焦触发 3 按钮触发
    this.buttonName = "按钮" //按钮名称
    this.buttonColor = "#2196F3"
    this.showAlert = 0 //是否显示弹窗 0 否 1 是
    this.alertText = "" // 弹窗文字内容
  }

  get title() {
    return this.fieldTitle
  }

  set title(title) {
    this.fieldTitle = title
    this.temTitle = title
  }

  get followHidden() {
    return this.isRelateField === 1 && !this.followShowList.length
  }

  // 是否展示必填提示
  get isShowTipsText() {
    let value = ""
    if (this.type === FORM_ITEM__RTF) {
      value = this.value
    } else if (this.type === FORM_ITEM__RELATE_RECORD) {
      value = this.value.instanceIdList
    } else if (this.type === FORM_ITEM__TABLE || this.type === FORM_ITEM__SECTION) {
      return false
    } else {
      value = this.valueToString(null)
    }
    return (this.root.status === FORM_STATUS__FILL
      && this.required
      && !value.length) || this.errorText.length
  }

  get tipsText() {
    if (this.errorText.length) {
      return ''
    }
    return this.requiredShowText
  }
}

// 权限可选列表
BaseItem.prototype.permissionOptional = [
  {
    value: PERMISSION__EDITOR,
    label: '编辑'
  },
  {
    value: PERMISSION__READ,
    label: '只读'
  },
  {
    value: PERMISSION__HIDDEN,
    label: '隐藏'
  }
]
// 宽度选项
BaseItem.prototype.percentList = [25, 50, 75, 100]
// 数据类型
BaseItem.prototype.dataType = DATA_TYPE__STRING
// 控件类型
BaseItem.prototype.type = ''
// 展示必填提示的文案
BaseItem.prototype.requiredShowText = '此项是必填项'

BaseItem.prototype.setPermission = function (permission) {
  const hasPermission = this.permissionOptional
    .map(permission => permission.value)
    .includes(permission)
  if (hasPermission) {
    this.permission = permission
  } else {
    this.permission = this.permissionOptional[0].value
  }
}
BaseItem.prototype.getStructure = function () {
  return {
    next: getId(this.next),
    prev: getId(this.prev),
    parent: getId(this.parent),
    firstChild: getId(this.firstChild)
  }
}
BaseItem.prototype.setStructure = function ({next, prev, parent, firstChild}) {
  this.next = next
  this.prev = prev
  this.parent = parent
  this.firstChild = firstChild
}
BaseItem.prototype.getBase = function () {
  return {
    dataId: this.dataId,
    type: this.type,
    dataType: this.dataType,
    fieldTitle: this.title,
    fieldDes: this.fieldDes,
    fieldHint: this.fieldHint,
    fieldDetail: this.fieldDetail,
    envVarName: this.envVarName,
    percent: this.percent,
    dependOnList: this.dependOnList,
    followList: this.followList,
    hidden: this.hidden,
    edit: this.edit,
    forTitle: this.forTitle,
    required: this.required,
    singleLine: this.singleLine,
    repeated: this.repeated,
    triggerType: this.triggerType,
    buttonName: this.buttonName,
    buttonColor: this.buttonColor,
    showAlert: this.showAlert,
    alertText: this.alertText,
  }
}
BaseItem.prototype.setBase = function (opts) {
  const {
    dataId,
    fieldTitle,
    fieldDes,
    fieldHint,
    fieldDetail,
    envVarName,
    percent,
    dependOnList,
    followList,
    hidden,
    edit,
    forTitle,
    required,
    singleLine,
    repeated,
    dependSubmit,
    triggerType,
    buttonName,
    buttonColor,
    showAlert,
    alertText
  } = opts

  this.dataId = dataId
  this.fieldTitle = fieldTitle || ''
  this.fieldDes = fieldDes || ''
  this.fieldHint = fieldHint || ''
  this.fieldDetail = fieldDetail || {}
  this.envVarName = envVarName || ''
  this.percent = percent || 100
  this.dependOnList = dependOnList || []
  this.followList = followList || []
  this.hidden = hidden || 0
  this.edit = edit === 0 ? 0 : 1
  this.forTitle = forTitle || 0
  this.required = required || 0
  this.singleLine = singleLine === 0 ? 0 : 1
  this.repeated = repeated === 0 ? 0 : 1
  this.dependSubmit = dependSubmit || 0
  this.triggerType = triggerType || 2
  this.buttonName = buttonName || '按钮'
  this.buttonColor = buttonColor || "#2196F3"
  this.showAlert = showAlert
  this.alertText = alertText || ''

  this.temTitle = this.title
}

BaseItem.prototype.checkVerify = function () {
}


// 修改了选项名--所有选项控件使用
BaseItem.prototype.optNameChange = function (val, item, options) {
  item.id = val
  for (let i = 1; i < 1000; i++) {
    if (options.map(item => item.optionName).filter(name => name === item.optionName).length > 1) {
      item.optionName = `${val}(${i})`
      item.id = `${val}(${i})`
    }
  }
}

export default BaseItem
